/* ==========================================================================
   LOYAL · THE MARK FILL, POINTER DRIVEN · 2026-08-02

   Kailin: "loyal wordmark and newspaper black white effect motion interactive
   when they move over loyal the blackwhite newspaper moves."

   WHAT IT DOES. The halftone plate behind the wordmark shifts as the pointer
   moves across the hero. The mark itself never moves. Only what shows THROUGH
   it does, which is the whole anchor law made interactive: the page is black,
   the brand appears only where the black is cut, and now the world behind the
   cut has parallax.

   IT DRIVES THE TOKENS THE THEME EDITOR ALREADY OWNS. There is no second
   positioning system. It reads the section's committed --mm-fill-x and
   --mm-fill-y as the REST position and moves around them, so whatever Kailin
   tuned by hand stays the centre of the motion rather than being overridden by
   it. Turn the interaction off and the page is exactly where she left it.

   WHY A LERP AND NOT A DIRECT MAP. Writing the pointer position straight into
   the custom property makes the fill twitch, because a pointer moves in jumps
   and a halftone is a high frequency texture that shows every one of them. The
   value eases toward its target at a fixed rate per frame, which is a spring
   without the overshoot, and MOTION-SYSTEM allows one overshoot maximum
   anywhere so it is not spent here.

   THREE THINGS IT REFUSES TO DO.
   · It does nothing under prefers-reduced-motion. No listener is even bound,
     so there is no idle rAF loop running for a visitor who asked for stillness.
   · It does nothing on a device with no fine pointer. A phone has no hover, and
     binding to touch would fight the scroll.
   · It never touches transform, opacity or layout. It writes two custom
     properties and the compositor does the rest, so it cannot cause a reflow.
   ========================================================================== */

(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (reduce.matches || !fine.matches) return;

  // How far the fill travels from rest, as a percentage of the fill box.
  // Small on purpose: the read is "the world behind the letters is alive",
  // not "the picture slides about".
  var RANGE_X = 7;
  var RANGE_Y = 5;
  var EASE = 0.085;

  function num(v) {
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  function bind(mark) {
    var host = mark.closest('.loyal-mm, section, .shopify-section') || mark.parentElement;
    if (!host) return;

    var cs = getComputedStyle(mark);
    var restX = num(cs.getPropertyValue('--mm-fill-x'));
    var restY = num(cs.getPropertyValue('--mm-fill-y'));

    var targetX = restX, targetY = restY;
    var curX = restX, curY = restY;
    var running = false;

    function frame() {
      var dx = targetX - curX;
      var dy = targetY - curY;

      // Park the loop once it is visually settled. An always-on rAF for an
      // animation nobody is driving is a battery cost with no payoff.
      if (Math.abs(dx) < 0.01 && Math.abs(dy) < 0.01) {
        curX = targetX; curY = targetY;
        mark.style.setProperty('--mm-fill-x', curX + '%');
        mark.style.setProperty('--mm-fill-y', curY + '%');
        running = false;
        return;
      }

      curX += dx * EASE;
      curY += dy * EASE;
      mark.style.setProperty('--mm-fill-x', curX.toFixed(3) + '%');
      mark.style.setProperty('--mm-fill-y', curY.toFixed(3) + '%');
      requestAnimationFrame(frame);
    }

    function kick() {
      if (running) return;
      running = true;
      requestAnimationFrame(frame);
    }

    host.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = host.getBoundingClientRect();
      if (!r.width || !r.height) return;

      // -0.5 .. 0.5 across the hero, then inverted, so the fill moves AGAINST
      // the pointer. Moving with it reads as dragging the image; moving
      // against it reads as looking through a window at something behind.
      var nx = (e.clientX - r.left) / r.width - 0.5;
      var ny = (e.clientY - r.top) / r.height - 0.5;
      targetX = restX - nx * RANGE_X * 2;
      targetY = restY - ny * RANGE_Y * 2;
      kick();
    }, { passive: true });

    host.addEventListener('pointerleave', function () {
      targetX = restX;
      targetY = restY;
      kick();
    }, { passive: true });

    // If the visitor turns reduced motion on mid-session, go home and stay.
    reduce.addEventListener('change', function (e) {
      if (!e.matches) return;
      targetX = curX = restX;
      targetY = curY = restY;
      mark.style.setProperty('--mm-fill-x', restX + '%');
      mark.style.setProperty('--mm-fill-y', restY + '%');
    });
  }

  function boot() {
    var marks = document.querySelectorAll('.loyal-mm__mark--fill');
    for (var i = 0; i < marks.length; i++) bind(marks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor re-renders a section into the DOM with no page load.
  document.addEventListener('shopify:section:load', boot);
})();
